import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MarketingNav from "@/components/site/MarketingNav";
import Footer from "@/components/site/Footer";
import { api } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data.posts)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="blog-index-page">
      <MarketingNav />
      <section className="border-b border-border">
        <div className="max-w-[1400px] mx-auto p-8 md:p-16">
          <div className="overline text-muted-foreground">The Draftwave Lab</div>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-none tracking-tight mt-4">
            Ideas we're
            <br />
            <span className="italic text-primary">testing in public.</span>
          </h1>
          <p className="mt-6 max-w-2xl text-muted-foreground">
            Every article answers: what problem does this solve, what can you try today, and how
            does Draftwave help. One clear next action per piece.
          </p>
        </div>
      </section>
      <section className="border-b border-border">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-3 border-l border-t border-border">
          {loading ? (
            <div className="col-span-3 p-16 overline text-muted-foreground">Loading…</div>
          ) : (
            posts.map((p) => (
              <Link
                key={p.id}
                to={`/blog/${p.slug}`}
                className="p-8 md:p-10 border-r border-b border-border hover-invert hover:bg-foreground hover:text-background group"
                data-testid={`blog-card-${p.slug}`}
              >
                <div className="overline opacity-60">
                  {new Date(p.published_at).toLocaleDateString()} · {p.tags?.[0] || "essay"}
                </div>
                <h2 className="font-serif-display text-3xl mt-4 leading-tight">{p.title}</h2>
                <p className="mt-3 text-sm opacity-80 line-clamp-3">{p.excerpt}</p>
                <div className="mt-6 overline text-primary group-hover:text-background">Read →</div>
              </Link>
            ))
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
